import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { convertToUtcDate, formatDateTime } from 'library/time';
import { Inner } from 'components/Page';
import config from './config';

/*
 ** @description Prepare data for api
 ** @param props Object route__id, reference_number, carrier, departure_time, arrival_time, active
 ** @return data object
 */
const handlePrepareData = ({
  route__id, reference_number, carrier, departure_time, arrival_time, active
}) => ({
  route_id: route__id,
  reference_number,
  carrier,
  departure_time: formatDateTime(convertToUtcDate(departure_time), 'HH:mm'),
  arrival_time: formatDateTime(convertToUtcDate(arrival_time), 'HH:mm'),
  active
});

const RouteLegs = ({
  objectId, permissions
}) => (
  <Inner
    classes="bhp-travel-booking-detail"
    canAdmin={permissions.CanAdminTravel()
      .hasPermissions()}
    reducer={{
      parent: REDUCER_KEY.travelRoutes,
      item: REDUCER_KEY.travelLeg,
      list: REDUCER_KEY.travelLegs
    }}
    config={{
      ...config,
      list: {
        ...config.list,
        filters: {
          route__id: [objectId]
        }
      },
      detail: {
        ...config.detail,
        parent: {
          route__id: objectId
        }
      }
    }}
    defaultSize="240px"
    scroll={{
      x: 700,
      y: '100%'
    }}
    onPrepareData={handlePrepareData}
    messaging={{
      delete: {
        disabled: () => 'Item Disabled.',
        failure: error => `Delete Failed. ${error}`,
        success: () => 'Delete Successful.'
      },
      save: {
        failure: () => 'Saving failed',
        success: () => 'Saving was successful'
      }
    }}
  />
);

RouteLegs.propTypes = {
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

RouteLegs.defaultProps = {
  objectId: null
};

export default RouteLegs;
